import Cards from "./Cards";

function AllSubmission({hackathons}){
    return (
        <Cards hackathons={hackathons} />
    )
}

export default AllSubmission;